import React, { memo, useCallback, useEffect } from "react";
import { useIntl } from "react-intl";
import { TextField } from "@material-ui/core";
import type { FC, ChangeEvent } from "react";
import { useBulkExportContext } from "../../../providers";
import { messages } from "./EmailInput.messages";
import { useStyles } from "./EmailInput.styles";
import { validate } from "./EmailInput.validator";

export const EmailInput: FC = memo(() => {
  const intl = useIntl();
  const classes = useStyles();
  const context = useBulkExportContext();

  const [isValid, updateValid] = React.useState(true);
  const [value, updateValue] = React.useState("");

  const placeholder = intl.formatMessage(messages.emailPlaceholder);
  const email = context?.state.email;
  const setEmail = context?.actions.setEmail;

  useEffect(() => {
    if (validate(email)) {
      updateValue(email!);
    }
  }, [email]);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      updateValue(value);
      updateValid(true);
    },
    [updateValue]
  );

  const handleBlur = useCallback(() => {
    if (validate(value)) {
      setEmail?.(value);
    } else {
      updateValid(false);
      setEmail?.('');
    }
  }, [value, setEmail, updateValid]);

  return (
    <TextField
      error={!isValid}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      InputProps={{
        classes,
      }}
    />
  );
});
